// // ============================================
// // src/components/home/HeroCarousel.tsx
// // ============================================
// "use client";
// import { Box, IconButton } from "@mui/material";
// import { useState, useEffect } from "react";
// import { ChevronLeft, ChevronRight } from "@mui/icons-material";
// import Image from "next/image";
// import { carouselData } from "@/data/carousel/carouselData";

// export default function HeroCarousel() {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isHovered, setIsHovered] = useState(false);

//   useEffect(() => {
//     if (isHovered) return;

//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % carouselData.length);
//     }, 10000);

//     return () => clearInterval(interval);
//   }, [isHovered]);

//   const nextSlide = () => {
//     setCurrentSlide((prev) => (prev + 1) % carouselData.length);
//   };

//   const prevSlide = () => {
//     setCurrentSlide((prev) => (prev - 1 + carouselData.length) % carouselData.length);
//   };

//   return (
//     <Box
//       sx={{
//         position: "relative",
//         width: "100%",
//         height: "100%",
//         borderRadius: 3,
//         overflow: "hidden",
//         boxShadow: "0 25px 70px rgba(0, 0, 0, 0.5)",
//         "&:hover .carousel-controls": {
//           opacity: 1,
//         },
//       }}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//     >
//       {/* SLIDES */}
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           height: 450,
//           overflow: "hidden",
//         }}
//       >
//         {carouselData.map((image, index) => (
//           <Box
//             key={index}
//             sx={{
//               position: "absolute",
//               inset: 0,
//               opacity: index === currentSlide ? 1 : 0,
//               transform: `translateX(${(index - currentSlide) * 100}%)`,
//               transition: "opacity 0.8s ease, transform 0.8s ease",
//             }}
//           >
//             <Image
//               src={image.src}
//               alt={image.alt}
//               fill
//               priority={index === 0}
//               sizes="(max-width: 900px) 100vw, 50vw"
//               style={{
//                 objectFit: "cover",
//                 filter: "brightness(0.85)",
//               }}
//             />

//             {/* GRADIENT OVERLAY */}
//             <Box
//               sx={{
//                 position: "absolute",
//                 inset: 0,
//                 background:
//                   "linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.55) 100%)",
//                 zIndex: 1,
//               }}
//             />

//             {/* DESCRIPTION */}
//             <Box
//               sx={{
//                 position: "absolute",
//                 bottom: { xs: 24, md: 48 },
//                 left: { xs: 20, md: 48 },
//                 zIndex: 2,
//                 color: "white",
//                 maxWidth: "70%",
//                 opacity: index === currentSlide ? 1 : 0,
//                 transform:
//                   index === currentSlide
//                     ? "translateY(0)"
//                     : "translateY(20px)",
//                 transition: "all 0.8s ease",
//               }}
//             >
//               <Box
//                 component="p"
//                 sx={{
//                   fontSize: { xs: "1.1rem", md: "1.2rem" },
//                   fontWeight: 600,
//                   lineHeight: 1.3,
//                   textShadow: "0 4px 20px rgba(0,0,0,0.7)",
//                 }}
//               >
//                 {image.description}
//               </Box>
//             </Box>
//           </Box>
//         ))}
//       </Box>

//       {/* CONTROLES */}
//       <Box
//         className="carousel-controls"
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: 0,
//           right: 0,
//           transform: "translateY(-50%)",
//           display: "flex",
//           justifyContent: "space-between",
//           px: 2,
//           opacity: 0,
//           transition: "opacity 0.3s ease",
//           zIndex: 3,
//         }}
//       >
//         <IconButton
//           onClick={prevSlide}
//           size="small"
//           sx={{
//             background: "rgba(0,0,0,0.6)",
//             color: "white",
//             "&:hover": {
//               background: "rgba(0,0,0,0.8)",
//               transform: "scale(1.1)",
//             },
//             transition: "all 0.3s ease",
//           }}
//         >
//           <ChevronLeft />
//         </IconButton>

//         <IconButton
//           onClick={nextSlide}
//           size="small"
//           sx={{
//             background: "rgba(0,0,0,0.6)",
//             color: "white",
//             "&:hover": {
//               background: "rgba(0,0,0,0.8)",
//               transform: "scale(1.1)",
//             },
//             transition: "all 0.3s ease",
//           }}
//         >
//           <ChevronRight />
//         </IconButton>
//       </Box>

//       {/* DOTS */}
//       <Box
//         sx={{
//           position: "absolute",
//           bottom: 16,
//           left: "50%",
//           transform: "translateX(-50%)",
//           display: "flex",
//           gap: 1,
//           zIndex: 3,
//         }}
//       >
//         {carouselData.map((_, index) => (
//           <Box
//             key={index}
//             onClick={() => setCurrentSlide(index)}
//             sx={{
//               width: 10,
//               height: 10,
//               borderRadius: "50%",
//               background:
//                 index === currentSlide
//                   ? "white"
//                   : "rgba(255, 255, 255, 0.4)",
//               cursor: "pointer",
//               transition: "all 0.3s ease",
//               "&:hover": {
//                 background: "white",
//                 transform: "scale(1.2)",
//               },
//             }}
//           />
//         ))}
//       </Box>
//     </Box>
//   );
// }







// HeroCarousel.tsx - Versión optimizada
"use client";
import { Box, IconButton } from "@mui/material";
import { useState, useEffect, useCallback, memo } from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Image from "next/image";
import { carouselData } from "@/data/carousel/carouselData";

// Constantes para estilos
const CAROUSEL_STYLES = {
  container: {
    position: "relative",
    width: "100%",
    height: "100%",
    borderRadius: 3,
    overflow: "hidden",
    boxShadow: "0 25px 70px rgba(0, 0, 0, 0.5)",
    "&:hover .carousel-controls": { opacity: 1 },
  } as const,
  
  slidesContainer: {
    position: "relative",
    width: "100%",
    height: 450,
    overflow: "hidden",
  } as const,
};

// Componente memoizado para cada slide
const CarouselSlide = memo(({ 
  image, 
  index, 
  currentSlide 
}: { 
  image: typeof carouselData[0];
  index: number;
  currentSlide: number;
}) => {
  const isActive = index === currentSlide;
  
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        opacity: isActive ? 1 : 0,
        transform: `translateX(${(index - currentSlide) * 100}%)`,
        transition: "opacity 0.8s ease, transform 0.8s ease",
      }}
    >
      {/* Usar unoptimized si hay problemas con compress: true */}
      <Image
        src={image.src}
        alt={image.alt}
        fill
        priority={index === 0}
        sizes="(max-width: 900px) 100vw, 50vw"
        unoptimized={process.env.NODE_ENV === 'development'} // ← IMPORTANTE
        style={{
          objectFit: "cover",
          filter: "brightness(0.85)",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.55) 100%)",
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: { xs: 24, md: 48 },
          left: { xs: 20, md: 48 },
          zIndex: 2,
          color: "white",
          maxWidth: "70%",
          opacity: isActive ? 1 : 0,
          transform: isActive ? "translateY(0)" : "translateY(20px)",
          transition: "all 0.8s ease",
        }}
      >
        <Box
          component="p"
          sx={{
            fontSize: { xs: "1.1rem", md: "1.2rem" },
            fontWeight: 600,
            lineHeight: 1.3,
            textShadow: "0 4px 20px rgba(0,0,0,0.7)",
          }}
        >
          {image.description}
        </Box>
      </Box>
    </Box>
  );
});

CarouselSlide.displayName = 'CarouselSlide';

function HeroCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Callbacks memoizados
  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % carouselData.length);
  }, []);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + carouselData.length) % carouselData.length);
  }, []);

  const goToSlide = useCallback((index: number) => {
    setCurrentSlide(index);
  }, []);

  useEffect(() => {
    if (isHovered) return;

    const interval = setInterval(nextSlide, 10000);
    return () => clearInterval(interval);
  }, [isHovered, nextSlide]);

  return (
    <Box
      sx={CAROUSEL_STYLES.container}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* SLIDES */}
      <Box sx={CAROUSEL_STYLES.slidesContainer}>
        {carouselData.map((image, index) => (
          <CarouselSlide
            key={image.alt}
            image={image}
            index={index}
            currentSlide={currentSlide}
          />
        ))}
      </Box>

      {/* CONTROLES */}
      <Box
        className="carousel-controls"
        sx={{
          position: "absolute",
          top: "50%",
          left: 0,
          right: 0,
          transform: "translateY(-50%)",
          display: "flex",
          justifyContent: "space-between",
          px: 2,
          opacity: 0,
          transition: "opacity 0.3s ease",
          zIndex: 3,
        }}
      >
        <IconButton
          onClick={prevSlide}
          size="small"
          sx={{
            background: "rgba(0,0,0,0.6)",
            color: "white",
            "&:hover": {
              background: "rgba(0,0,0,0.8)",
              transform: "scale(1.1)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ChevronLeft />
        </IconButton>

        <IconButton
          onClick={nextSlide}
          size="small"
          sx={{
            background: "rgba(0,0,0,0.6)",
            color: "white",
            "&:hover": {
              background: "rgba(0,0,0,0.8)",
              transform: "scale(1.1)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ChevronRight />
        </IconButton>
      </Box>

      {/* DOTS */}
      <Box
        sx={{
          position: "absolute",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: 1,
          zIndex: 3,
        }}
      >
        {carouselData.map((_, index) => (
          <Box
            key={index}
            onClick={() => goToSlide(index)}
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: index === currentSlide ? "white" : "rgba(255, 255, 255, 0.4)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                background: "white",
                transform: "scale(1.2)",
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
}

export default memo(HeroCarousel);